module.exports = __webpack_public_path__ + "static/media/combinou.3b32a136.svg";